import { formatDate } from "../../../../Util/format_date"
import img_not_read from '../../images/check_notread.png'
import img_read from '../../images/check_read.png'

export default function CardMessage({ message, progressElem, showProgress, progressFile, progressInner }) {

    const click_image = (e) => {

        let _src = e.target.src
        let _img = document.createElement('div')

        _img.className = 'image_message_full'
        _img.style.backgroundImage = `url(${_src})`

        setTimeout(() => {
            _img.style.opacity = '1'
        }, 100)

        _img.addEventListener('transitionend', () => {
            _img.style.transition = 'none'
        })
        _img.addEventListener('transitionstart', () => {
            _img.style.transition = 'all .3s'
        })
        _img.addEventListener('transitioncancel', () => {
            _img.style.transition = 'all .3s'
        })
        _img.addEventListener('transitionrun', () => {
            _img.style.transition = 'all .3s'
        })
        _img.addEventListener('click', () => {
            _img.remove()
        })
        document.body.appendChild(_img)

    }

    const creat_download_link = (url, message) => {

        if (!message.my_file) {

            let _url_arr = url.split('.')
            let file_type = _url_arr[_url_arr.length - 1]

            fetch(
                url
            ).then((response) => {
                response.blob().then((blob) => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = `file.${file_type}`;
                    a.click();
                });
                //window.location.href = response.url;
            });

        }


    }

    return (
        <div className={"card_message " + message.sender}>
            {message.type == 'text' ?
                <p className="message">{message.value}</p> :
                <div className="message">
                    {(showProgress && progressFile == 'progress') && <div className="progress_file_message" ref={progressElem}>
                        <div className="progress_percent_file_message">
                            <p className="percent_message">{progressInner}%</p>
                        </div>
                    </div>}
                    {message.type == 'image' && <img className="image_message" onClick={click_image} src={message.value} alt="" />}
                    {message.type == 'video' && <video onClick={() => creat_download_link(message.value, message)} className="image_message" src={message.value} autoPlay loop muted></video>}
                    {message.type == 'audio' && <audio className="image_message" src={message.value} controls></audio>}
                </div>
            }
            <p className="time_in_message">{formatDate(new Date(message.time), 'yyyy/MM/dd,  HH:mm')}
                {message.sender == 'user' && <img src={message.is_read ? img_read : img_not_read} alt="" />}
            </p>
        </div>
    )
}